// Mock data para desarrollo
const mockUsers = [
  {
    id: 1,
    email: 'admin@educapp.cl',
    password: 'admin123',
    role: 'administrador',
    name: 'Juan Carlos Pérez',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 8765 4321',
    permissions: ['all']
  },
  {
    id: 2,
    email: 'gestor@educapp.cl',
    password: 'gestor123',
    role: 'gestor',
    name: 'Ana María González',
    avatar: 'https://images.unsplash.com/photo-1494790108755-2616c3c611cb?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 7654 3210',
    permissions: ['users', 'courses', 'projects', 'calendar']
  },
  {
    id: 3,
    email: 'profesor@educapp.cl',
    password: 'prof123',
    role: 'profesor',
    name: 'María José Rodríguez',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 6543 2109',
    subjects: ['Matemáticas', 'Ciencias'],
    permissions: ['projects', 'evaluations', 'messages']
  },
  {
    id: 4,
    email: 'alumno@educapp.cl',
    password: 'alum123',
    role: 'alumno',
    name: 'Carlos Eduardo Silva',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 5432 1098',
    course: '8° Básico A',
    rut: '20.123.456-7',
    permissions: ['projects', 'grades', 'messages']
  },
  {
    id: 5,
    email: 'apoderado@educapp.cl',
    password: 'apod123',
    role: 'apoderado',
    name: 'Patricia Elena Morales',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=40&h=40&fit=crop&crop=face',
    phone: '+56 9 4321 0987',
    children: [{ id: 4, name: 'Carlos Eduardo Silva', course: '8° Básico A' }],
    permissions: ['messages', 'payments', 'reports']
  }
];

// Simular delay de red
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class AuthService {
  constructor() {
    this.currentUser = null;
    this.token = null;
  }

  async login(email, password) {
    await delay(1000); // Simular delay de red

    try {
      const user = mockUsers.find(u => u.email === email && u.password === password);
      
      if (!user) {
        return {
          success: false,
          message: 'Credenciales incorrectas'
        };
      }

      // Crear una copia del usuario sin la contraseña
      const userData = { ...user };
      delete userData.password;

      // Generar token mock
      const token = this.generateMockToken(userData);

      this.currentUser = userData;
      this.token = token;

      return {
        success: true,
        data: {
          user: userData,
          token: token
        }
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error interno del servidor'
      };
    }
  }

  async logout() {
    await delay(500);
    this.currentUser = null;
    this.token = null;
    return { success: true };
  }

  async validateToken(token) {
    await delay(300);
    
    try {
      // Validar formato básico del token
      const parts = token.split('.');
      if (parts.length !== 3) return false;

      // Decodificar payload (base64)
      const payload = JSON.parse(atob(parts[1]));
      
      // Verificar expiración
      if (payload.exp < Date.now() / 1000) {
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  async refreshToken(refreshToken) {
    await delay(500);
    
    if (!refreshToken) {
      throw new Error('Refresh token requerido');
    }

    // Simular renovación del token
    const newToken = this.generateMockToken(this.currentUser);
    
    return {
      success: true,
      data: {
        token: newToken
      }
    };
  }

  async resetPassword(email) {
    await delay(1000);
    
    const user = mockUsers.find(u => u.email === email);
    
    if (!user) {
      return {
        success: false,
        message: 'No se encontró una cuenta con ese email'
      };
    }

    // Simular envío de email
    console.log(`Email de recuperación enviado a: ${email}`);
    
    return {
      success: true,
      message: 'Se ha enviado un email con las instrucciones para recuperar tu contraseña'
    };
  }

  async changePassword(currentPassword, newPassword) {
    await delay(800);
    
    if (!this.currentUser) {
      return {
        success: false,
        message: 'Usuario no autenticado'
      };
    }

    // Verificar contraseña actual
    const user = mockUsers.find(u => u.id === this.currentUser.id);
    if (!user || user.password !== currentPassword) {
      return {
        success: false,
        message: 'Contraseña actual incorrecta'
      };
    }

    // Actualizar contraseña en mock data
    user.password = newPassword;
    
    return {
      success: true,
      message: 'Contraseña actualizada correctamente'
    };
  }

  async updateProfile(userData) {
    await delay(600);
    
    if (!this.currentUser) {
      return {
        success: false,
        message: 'Usuario no autenticado'
      };
    }

    // Actualizar datos del usuario
    const userIndex = mockUsers.findIndex(u => u.id === this.currentUser.id);
    if (userIndex !== -1) {
      mockUsers[userIndex] = { ...mockUsers[userIndex], ...userData };
      this.currentUser = { ...this.currentUser, ...userData };
    }

    return {
      success: true,
      data: this.currentUser,
      message: 'Perfil actualizado correctamente'
    };
  }

  generateMockToken(user) {
    const header = {
      alg: 'HS256',
      typ: 'JWT'
    };

    const payload = {
      sub: user.id,
      email: user.email,
      role: user.role,
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + (24 * 60 * 60) // 24 horas
    };

    // Simular JWT (no es seguro, solo para desarrollo)
    const headerBase64 = btoa(JSON.stringify(header));
    const payloadBase64 = btoa(JSON.stringify(payload));
    const signature = btoa('mock-signature');

    return `${headerBase64}.${payloadBase64}.${signature}`;
  }

  getCurrentUser() {
    return this.currentUser;
  }

  getToken() {
    return this.token;
  }

  isAuthenticated() {
    return !!this.currentUser && !!this.token;
  }

  hasRole(role) {
    return this.currentUser && this.currentUser.role === role;
  }

  hasPermission(permission) {
    if (!this.currentUser || !this.currentUser.permissions) return false;
    return this.currentUser.permissions.includes(permission) || this.currentUser.permissions.includes('all');
  }
}

export const authService = new AuthService();